import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

export const getFormations = () => api.get("/formations").then((r) => r.data);
export const getFormation = (slug) => api.get(`/formations/${slug}`).then((r) => r.data);
export const getActualites = () => api.get("/actualites").then((r) => r.data);
export const getActualite = (slug) => api.get(`/actualites/${slug}`).then((r) => r.data);
export const postMessage = (payload) => api.post("/messages", payload).then((r) => r.data);
